import { z } from "zod";
import { instantSchema } from "./schemas";

/*
 * Runtime schemas of the geofence reminder (T-188, ADR-0167). They mirror `backend/openapi.json`
 * like `schemas.ts`.
 */

/** The region of an own establishment: coordinates with three decimal places and a radius. */
export const geofenceRegionSchema = z.object({
  establishmentId: z.uuid(),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  radiusMeters: z.number().int().min(100).max(1000),
});

/** A period in which a working day or a shift is due. */
export const geofenceWindowSchema = z.object({
  start: instantSchema,
  end: instantSchema,
});

/** `GET /me/geofence-reminder`: what the app needs to remind on the device; it sends nothing back. */
export const myGeofenceReminderSchema = z.object({
  enabled: z.boolean(),
  generatedAt: instantSchema,
  until: instantSchema,
  regions: z.array(geofenceRegionSchema),
  windows: z.array(geofenceWindowSchema),
  shiftStarts: z.array(instantSchema),
});

/** `GET` and `PUT /tenants/{id}/geofence-reminder`. */
export const tenantGeofenceReminderSchema = z.object({
  enabled: z.boolean(),
  entitled: z.boolean(),
  active: z.boolean(),
});

/** The region of an own establishment. */
export type GeofenceRegionAnswer = z.infer<typeof geofenceRegionSchema>;
/** What the app of the person gets for the geofence reminder. */
export type MyGeofenceReminder = z.infer<typeof myGeofenceReminderSchema>;
/** The geofence reminder as the tenant administrator sees it. */
export type TenantGeofenceReminder = z.infer<typeof tenantGeofenceReminderSchema>;

/** Query keys of the geofence reminder. */
export const geofenceQueryKeys = {
  mine: ["me", "geofence-reminder"] as const,
  tenant: (tenantId: string) => ["tenant", tenantId, "geofence-reminder"] as const,
};
